import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';
import { ServerPath } from '../../../Constant';
import { _axios } from '../../../utils/axios';
import Swal from 'sweetalert2';

const AddJourney = () => {
    const [show, setShow] = useState(false);
    const [locationName, setLocationName] = useState('');
    const [location, setLocation] = useState('');
    const navigate = useNavigate();

    const handleClose = () => {
        setShow(false);
        // Reset form fields when closing the modal
        setLocationName('');
        setLocation('');
    };
    const handleShow = () => setShow(true);

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Check if any field is empty
        if (!locationName.trim() || !location.trim()) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'All fields are required',
                confirmButtonColor: '#3085d6',
            });
            return;
        }

        const newTagDetails = {
            location_name: locationName.trim(),
            location: location.trim(),
            status: 1,
        };

        try {
            const response = await _axios.post(`${ServerPath}/journey/create`, newTagDetails);
            console.log("res ", response.data);
            handleClose();
            window.location.reload();


            // Swal.fire({
            //     icon: 'success',
            //     title: 'Success',
            //     text: 'Location created successfully!',
            //     confirmButtonColor: '#3085d6',
            // }).then(() => {
            //     navigate(0);
            // });
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while creating the location',
                confirmButtonColor: '#3085d6',
            });
        }
    };

    return (
        <>
            <button onClick={handleShow} className='btn btn-primary float-end'>Create Locations</button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Create Start Journey Locations</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="formlocationName">
                                <Form.Label>Location Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={locationName}
                                    onChange={(e) => setLocationName(e.target.value)}
                                    placeholder="Enter location name"
                                    required
                                />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} controlId="formLocation">
                                <Form.Label>Address <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={location}
                                    onChange={(e) => setLocation(e.target.value)}
                                    placeholder="Enter complete URL address"
                                    required
                                />
                            </Form.Group>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Close</Button>
                    <Button variant="primary" onClick={handleSubmit}>Create Location</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AddJourney;